import React from 'react';
import Wrapper from "./Wrapper";
import logo from '../assets/Images/logo.svg';
import Account from "./Account";
import HeaderSearch from "./HeaderSearch";
import {Link} from 'react-router-dom';

const Footer = ({className}) => {
    return (
        <footer className={`${className} relative py-4 border-t-2 text-black`}>
            <Wrapper className='flex-col'>
                <div className='relative w-full justify-center md:text-2xl text-md lg:text-md flex'>
                    تمامی حقوق
                    <span className='flex items-center ml-2 mr-2 text-light-primary'>
                        <span>کدپرو</span>
                        <img src={logo} alt='logo' className='h-6 block mr-2 rounded-sm'/>
                    </span> محفوظ
                    می
                    باشد &copy;
                </div>
            </Wrapper>
        </footer>
    );
};

export default Footer;